import { RightWrapper } from "../../../components";
import EmployeeLoginForm from "./EmployeeLoginForm";
import { Button, DataTable } from "@/components";
import { FaPlus } from "react-icons/fa6";
import { useMemo, useEffect, useState } from "react";
import ColumnHelper from "@/utils/ColumnHelper";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { useDispatch, useSelector } from "react-redux";
import {
  selectAllEmployeesLogin,
  removeEmployeesLogin,
  fetchEmployeesLogin,
} from "../../../app/slices";
import {useAlert} from "@/"
const EmployeeLogin = () => {
  const {alert, AlertDialog} = useAlert();
  const [sheetOpen, setSheetOpen] = useState(false);

  const dispatch = useDispatch();

  const employeesLogin = useSelector(selectAllEmployeesLogin) || [];

  useEffect(() => {
    dispatch(fetchEmployeesLogin());
  }, [dispatch]);

  console.log("EmployeesLogin:::: ", employeesLogin);
  const isLoadingEmployeesLogin = useSelector(
    (state) => state.employeesLogin.loading
  );
  const handleDelete = async (id) => {
    try {
      console.log("Deleting Employee with ID:", id);
      const response = await dispatch(removeEmployeesLogin(id));

      if (removeEmployeesLogin.fulfilled.match(response)) {
        console.log("Employee deleted successfully:", response.payload);
        alert("Employee deleted successfully");
      } else {
        console.error("Failed to delete employee:", response.payload);
        alert(
          `Failed to delete employee: ${response.payload || "Unknown error"}`
        );
      }
    } catch ({error}) {
      console.error("Error deleting employee:", error.message);
      alert("An unexpected error occurred while deleting the employee");
    }
  };
  const columns = useMemo(
    () => [
      ColumnHelper({
        header: "Employee Name",
        accessorKey: "name",
        meta: {
          tooltip: (row) => row.name || "N/A",
        },
      }),
      ColumnHelper({
        header: "Mobile",
        accessorKey: "phoneNumber",
        meta: {
          tooltip: (row) => row.phoneNumber,
        },
      }),
      ColumnHelper({
        header: "Mail ID",
        accessorKey: "email",
        meta: {
          tooltip: (row) => row.email || "N/A",
        },
      }),
      ColumnHelper({
        header: "Permission",
        accessorKey: "permissions",
        meta: {
          tooltip: (row) => row.permissions?.join(", ") || "N/A",
        },
        cell: (info) => info.row.original.permissions?.join(", ") || "N/A",
      }),
      ColumnHelper({
        header: "Actions",
        accessorKey: "id",
        cell: (info) => (
          <div className="flex gap-1 justify-start items-center">
            <Button
              size="xs"
              onClick={() => handleDelete(info.row.original.id)}
            >
              Delete
            </Button>
          </div>
        ),
        meta: {
          tooltip: () => " delete employee record",
        },
      }),
    ],
    []
  );
  return (
    <RightWrapper>
      <div className="flex flex-col gap-4 m-2 pb-20 md:pb-4">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row lg:justify-between items-end gap-6 lg:gap-2">
          <div className="flex flex-col gap-1 w-full">
            <h1 className="text-headline4 md:text-headline3 font-nunito text-secondary/95 font-semibold">
              Employee Logins
            </h1>
            <p className="text-body2 font-ptsans text-secondary/60 lg:w-[50%]">
              Securely manage employee access with role-based logins, ensuring
              controlled access to essential logistics operations.
            </p>
          </div>

          {/* Add New Employee Button */}
          <Sheet open={sheetOpen} onOpenChange={setSheetOpen}>
            <SheetTrigger asChild>
              <Button size="sm" icon={FaPlus}>
                Add New Login
              </Button>
            </SheetTrigger>
            <SheetContent aria-describedby="">
              <SheetHeader>
                <SheetTitle>Add New Employee</SheetTitle>
              </SheetHeader>
              <EmployeeLoginForm setSheetOpen={setSheetOpen} />
            </SheetContent>
          </Sheet>
        </div>
        <DataTable
          columns={columns}
          tittle="Employee Login"
          data={employeesLogin}
          isLoading={isLoadingEmployeesLogin}
          showCheckbox={false}
        />
      </div>
      <AlertDialog/>
    </RightWrapper>
  );
};

export default EmployeeLogin;
